import React from 'react';
import PropTypes from "prop-types";
import {
  NoticeBorder, NoticeContent, NoticeContainer, SubmitBold, ShowMoreWrap,SecondaryButtonWrapper
} from './styles';
import downArrow from "../../../../../../../assets/icons/short-arrow-b.svg";
import upArrow from "../../../../../../../assets/icons/short-arrow-t.svg";


class Alert extends React.Component {
  state = {
    show: false
  };

  toggleNoticeBlock = () => {
    this.setState({ show: !this.state.show });
  };

  render() {
    return (
  <div className="fluid">
    <NoticeBorder>
      <NoticeContainer
        message={(
          <NoticeContent className="flex">
            <div>
              <SubmitBold>
                {this.props.noticeSubject || "Notice:"}
                {' '}
              </SubmitBold>
              <div dangerouslySetInnerHTML={{__html: this.props.message}}></div>
              {this.state.show ?
            <div dangerouslySetInnerHTML={{__html: this.props.showMoreMessage}}></div>
            : ''
            }
            </div>
            
            <ShowMoreWrap>
            {this.state.show ? (
                    <SecondaryButtonWrapper onClick={this.toggleNoticeBlock}>
                      <span>Show Less</span> <img src={upArrow} alt="rise" />
                    </SecondaryButtonWrapper>
                  ) : (
                    <SecondaryButtonWrapper onClick={this.toggleNoticeBlock}>
                      <span>Show More</span> <img src={downArrow} alt="fall" />
                    </SecondaryButtonWrapper>
                  )}
            </ShowMoreWrap>
          </NoticeContent>
        )}
      />
    </NoticeBorder>
  </div>
);
}
}

Alert.propTypes = {
  noticeSubject: PropTypes.string,
  message: PropTypes.string,
  showMoreMessage: PropTypes.string,
  toggleNoticeBlock: PropTypes.func
}

export default Alert;